import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import resources from '../../translations/resources';

/**
 * German UI texts for all installed plugins.
 *
 * The translation files live under `translations/messages/*.de.json` and are maintained
 * with `yarn backstage-cli translations export|import`; `translations/resources.ts` is
 * generated. Untranslated keys fall back to English automatically.
 */
export const translationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: resources.map(resource =>
    TranslationBlueprint.make({
      // The ref ID contains dots, which are not allowed in extension names.
      name: `de-${resource.id.replace(/[^a-z0-9-]/gi, '-')}`,
      params: { resource },
    }),
  ),
});
